import React, { FC } from 'react';
import '../css/outlet.css';
import { Outlet, useMatch } from 'react-router-dom';
import Header from '../../header/ts/header';
import Footer from '../../footer/ts/footer';
import SCLLogoIcon from '../../../../assets-module/asset-configuration/image/logoFooterSdx.png';

const MainOutlet: FC = () => {
  const hideFooter = useMatch('/career/position/all');
  return (
    <div className='scl--main-layout-container'>
      <div className='scl--app-fixed-header'>
        <Header/>
      </div>

      <main className={`scl--outlet-main-container`}>
        <div className="scl--main-content-mid-style-container">
          <Outlet />
        </div>
      </main>

      {!hideFooter &&
        <div className='scl--app-fixed-footer'>
          <Footer logoIcon={SCLLogoIcon} logoAlt='Logo'/>
        </div>
      }
      
    </div>
  );
};

export default MainOutlet;